export default __webpack_public_path__ + "assets/full-logo-blockchain-lightblue-ec47cedd51af20f23872289bcc605034.svg";